import React, { useCallback, useEffect, useRef, useState } from "react";
// import StatusBar from "../../../EmployeeVisitContainer/NewEmployeeVisitDetailView/RightContent/PhysicalTab/StatusBar";
import {
  capitalizeName,
  isSet,
  toQueryString,
} from "../../../../utils/commonUtils";
import Icons from "../../../../components/UI/Icons";
import TableHeader from "../../../../components/UI/TableGrid/TableHeader";
import TableGrid from "../../../../components/UI/TableGrid";
import EmrVisitsService from "../../../../services/EmrVisitsService";
import NewAddVaccine from "./NewAddVaccine";
import ActivityCharts from "../../../EmployeeVisitContainer/EmployeeVisitDetailView/RightContent/ActivityChart";
import { connect } from "react-redux";
import withReduxState from "../../../../hoc/wReduxState";
import WithRouter from "../../../../hoc/WithRouter";
import WithRoutify from "../../../../hoc/WithRoutify";
import EmployeeService from "../../../../services/EmployeeService";
import LookupService from "../../../../services/LookupService";
import NewRadiologyPage from "./NewRadiologyPage";
import { getOverAllStatusIcon } from "../../../../utils/visitUtils";
import { Modal, Toast } from "react-bootstrap";
import EmrStatusBar from "../ComplaintPage/EmrStatusBar";
import PatientChartsService from "../../../../services/PatientChartsService";
import FileManagerService from "../../../../services/FileManagerService";
import AiDiagnosisService from "../../../../services/AiDiagnosisService";
import ActivityChargesList from "../../NewUIEmrPage/ActivityChargesList";


const AllOrdersPage = (props) => {
  const profile = props.profile || {};
  // Keep this aligned with AIPrediction gating logic (e.g. NewIcdDisplay.js).
  const aiSuggestionsEnabled = profile?.ai_suggestions_enabled ?? false;
  const tableHeaders = [
    // { label: '',key:'statusicon'},
   // { label: "Status", key: "status" },
    { label: "Order Placed", key: "emr_activity_name" },
    // { label: 'Activity Type',key:'emr_activity_type'},
    { label: "Time Placed", key: "timePlaced" },
    { label: "Total Time", key: "totalTime" },
    { label: "Result", key: "labeled_status" },
    { label: "Activity Status", key: "status_badge" },
   
    // { label: 'Consent Status',key:'consent'},
    { label: "Actions", key: "action", type: "Actions" },
    // Add more columns as needed
  ];
  const [isLabModelOpen, setIsLabModelOpen] = useState(false);
  const [isVaccineModelOpen, setIsVaccineModelOpen] = useState(false);
  const [activityChartDetails, setActivityChartDetails] = useState({});
  const [isActivityChartOpen, setIsActivityChartOpen] = useState(false);
  const [employeeDetails, setEmployeeDetails] = useState({});
  const [lookupsOptions, setLookupsOptions] = useState({
    shippingService: [],
    chartResult: [],
  });
  const [orderCounts, setOrderCounts] = useState({
    ready: { total: 0, labs: 0, xrays: 0, others: 0 },
    pending: { total: 0, labs: 0, xrays: 0, others: 0 },
    completed: { total: 0, labs: 0, xrays: 0, others: 0 },
  });
  const [isOrdersAiPredictiveOpen, setIsOrdersAiPredictiveOpen] = useState(true);
  const [ordersAiLoading, setOrdersAiLoading] = useState(false);
  const [ordersAiError, setOrdersAiError] = useState("");
  const [ordersAiLoadingStep, setOrdersAiLoadingStep] = useState(0);

  const aiPredictiveCardStyle = {
    padding: "8px",
    borderRadius: "12px",
    border: "2px solid transparent",
    background:
      "linear-gradient(#fff, #fff) padding-box, linear-gradient(76.49deg, #C6CCFF 0.38%, #F1F3FC 99.62%) border-box",
  };
  const aiPredictiveTitleStyle = {
    color: "#1D2433",
    fontSize: "13px",
    fontWeight: 700,
  };
  const aiPredictiveListStyle = {
    background: "linear-gradient(180deg, #FFE9FF 0%, #FDEFFF 40%, #FDF3FF 100%)",
    padding: "8px",
    maxHeight: "500px",
    overflowY: "auto",
    scrollbarWidth: "thin",
    borderRadius: "8px",
  };
  const aiPredictiveCodeStyle = { color: "#1D2433", fontSize: "13px", fontWeight: 700, lineHeight: 1.25 };
  const aiPredictiveDescStyle = {
    color: "#4B5563",
    fontSize: "13px",
    lineHeight: 1.35,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    maxHeight: "2.7em",
  };
  const aiChevronStyle = {
    transform: isOrdersAiPredictiveOpen ? "rotate(180deg)" : "rotate(0deg)",
    transition: "transform 0.2s ease",
    cursor: "pointer",
  };

  const [ordersAiSuggestions, setOrdersAiSuggestions] = useState([]);
  const [selectedOrderSuggestion, setSelectedOrderSuggestion] = useState(null);
  const [showOrderAiPreviewModal, setShowOrderAiPreviewModal] = useState(false);

  const ordersAiLoadingMessages = [
    "Analyzing chief complaint and presenting problem...",
    "Reviewing HPI, ROS, and examination findings...",
    "Applying clinical safety guardrails...",
    "Identifying high-yield diagnostic needs...",
    "Generating evidence-based orders...",
    "Prioritizing orders for clinical relevance...",
    "Finalizing recommendations...",
  ];

  useEffect(() => {
    if (!ordersAiLoading) {
      setOrdersAiLoadingStep(0);
      return;
    }

    // Advance message every 2 seconds, stop at the last one.
    const intervalId = setInterval(() => {
      setOrdersAiLoadingStep((prev) => {
        const next = prev + 1;
        return next >= ordersAiLoadingMessages.length ? prev : next;
      });
    }, 2000);

    return () => clearInterval(intervalId);
  }, [ordersAiLoading]);

  const mapOrdersAiSuggestions = (suggestions = []) => {
    return suggestions.map((item, idx) => {
      const confidence = item.confidence;
      const numeric =
        typeof confidence === "number"
          ? confidence <= 1
            ? Math.round(Number(confidence) * 100)
            : Math.round(Number(confidence))
          : null;

      let parsedDescription = null;
      if (typeof item.description === "string") {
        try {
          const maybe = JSON.parse(item.description);
          if (maybe && typeof maybe === "object") {
            parsedDescription = maybe;
          }
        } catch (e) {
          parsedDescription = null;
        }
      }

      const activityName =
        parsedDescription?.activity_name ||
        parsedDescription?.order_name ||
        item.description ||
        "Suggested order";
      const rationaleText =
        parsedDescription?.rationale ||
        item.description ||
        "";
      const rationaleSections =
        parsedDescription?.rationale_sections &&
        typeof parsedDescription.rationale_sections === "object"
          ? parsedDescription.rationale_sections
          : {};

      return {
        id: item.id || idx,
        suggestionId: item.id,
        category: item.code || "Order",
        title: activityName,
        rationale: rationaleText,
        rationaleSections,
        isAccepted: Boolean(item.is_accepted),
        confidenceLabel:
          item.confidenceLabel ||
          (numeric !== null ? `Confidence Level: ${numeric}%` : "Confidence Level: N/A"),
      };
    });
  };

  const openOrderAiPreview = (item) => {
    if (!item || item.isAccepted) return;
    setSelectedOrderSuggestion(item);
    setShowOrderAiPreviewModal(true);
  };

  const getOrderPreviewSections = (item) => {
    if (!item) return [];
    const entries =
      item.rationaleSections && typeof item.rationaleSections === "object"
        ? Object.entries(item.rationaleSections).filter(
            ([k, v]) => String(k || "").trim() && String(v || "").trim()
          )
        : [];

    if (entries.length > 0) {
      return entries.map(([label, value]) => ({
        label: String(label).trim(),
        value: String(value).trim(),
      }));
    }

    const fallback = String(item.rationale || "").trim();
    if (!fallback) return [];
    return [{ label: "Rationale", value: fallback }];
  };

  const handleOrdersReloadSuggestions = async (e) => {
    if (e) e.stopPropagation();

    if (!aiSuggestionsEnabled) {
      return;
    }

    try {
      const visitId = props.visit_id;
      const organizationId =
        props.visitDetails?.organization_id ||
        props.visitDetails?.company?.organization_id;
      const employeeId = props.visitDetails?.employee?.employee_id || null;

      if (!visitId || !organizationId) {
        setOrdersAiError("Missing visit or organization details");
        return;
      }

      setOrdersAiLoading(true);
      setOrdersAiError("");

      await AiDiagnosisService.generateSuggestionsByVisit(
        visitId,
        organizationId,
        employeeId,
        "orders"
      );

      const data = await AiDiagnosisService.getSuggestions(visitId, "orders");
      const suggestions = data?.suggestions || [];

      if (suggestions.length) {
        const mapped = mapOrdersAiSuggestions(suggestions);
        setOrdersAiSuggestions(mapped);
      }
    } catch (err) {
      setOrdersAiError(err?.message || "Unable to reload AI orders suggestions");
    } finally {
      setOrdersAiLoading(false);
    }
  };

  // Load any previously stored Orders AI suggestions when visit changes (or when panel is shown).
  // If no data exists, automatically call generate API.
  const fetchStoredOrdersSuggestions = async () => {
    if (!aiSuggestionsEnabled) {
      setOrdersAiSuggestions([]);
      return [];
    }
    const visitId = props.visit_id;
    if (!visitId) return [];
    try {
      setOrdersAiLoading(true);
      setOrdersAiError("");

      const data = await AiDiagnosisService.getSuggestions(visitId, "orders");
      const suggestions = data?.suggestions || [];

      if (suggestions.length) {
        const mapped = mapOrdersAiSuggestions(suggestions);
        setOrdersAiSuggestions(mapped);
      } else {
        setOrdersAiSuggestions([]);
      }
      return suggestions;
    } catch (err) {
      setOrdersAiError("");
      return [];
    } finally {
      setOrdersAiLoading(false);
    }
  };

  useEffect(() => {
    if (!props.visit_id || !aiSuggestionsEnabled) return;

    fetchStoredOrdersSuggestions().then((suggestions) => {
      if (!suggestions || suggestions.length === 0) {
        const visitId = props.visit_id;
        const organizationId =
          props.visitDetails?.organization_id ||
          props.visitDetails?.company?.organization_id;
        const employeeId = props.visitDetails?.employee?.employee_id || null;

        if (visitId && organizationId) {
          setOrdersAiLoading(true);
          AiDiagnosisService.generateSuggestionsByVisit(
            visitId,
            organizationId,
            employeeId,
            "orders"
          )
            .then(() => fetchStoredOrdersSuggestions())
            .catch((err) =>
              setOrdersAiError(err?.message || "Unable to generate AI orders suggestions")
            )
            .finally(() => setOrdersAiLoading(false));
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visit_id, aiSuggestionsEnabled]);

  const handleOrdersApplySuggestion = async (suggestion) => {
    if (!aiSuggestionsEnabled) {
      return;
    }
    const visitId = props.visit_id;
    const organizationId =
      props.visitDetails?.organization_id ||
      props.visitDetails?.company?.organization_id;

    if (!visitId || !organizationId) {
      setOrdersAiError("Missing visit or organization details");
      return;
    }
    const suggestionId = suggestion?.suggestionId;
    if (!suggestionId) return;

    try {
      setOrdersAiLoading(true);
      setOrdersAiError("");
      await AiDiagnosisService.acceptSuggestion(
        suggestionId,
        organizationId,
        visitId
      );

      // Refresh Orders/Results table
      await fetchPhysicalList();

      // Refresh AI suggestions list
      const data = await AiDiagnosisService.getSuggestions(visitId, "orders");
      const suggestions = data?.suggestions || [];

      if (suggestions.length) {
        const mapped = mapOrdersAiSuggestions(suggestions);
        setOrdersAiSuggestions(mapped);
      } else {
        setOrdersAiSuggestions([]);
      }
      setShowOrderAiPreviewModal(false);
      setSelectedOrderSuggestion(null);
    } catch (err) {
      setOrdersAiError(err?.message || "Unable to place AI orders");
    } finally {
      setOrdersAiLoading(false);
    }
  };

  const addLabToogleHandler = (chartDetails = {}, chartOpen = false) => {
    // Create chartDetails for new lab order if not provided
    const labChartDetails = chartDetails && Object.keys(chartDetails).length > 0 
      ? chartDetails 
      : {
          activity_name: "Lab",
          activity_type: "Lab",
          actitivity_id: null,
          mapping_id: chartDetails.field_id || null,
          field_id: chartDetails.field_id || null,
          lab_order_result_id: null,
          hasOrder: "false"
        };
    setIsLabModelOpen((prev) => !prev);
    setActivityChartDetails(labChartDetails);
  };

  const addVaccineToogleHandler = (chartDetails = {}) => {
    setIsVaccineModelOpen((prev) => !prev);
    setActivityChartDetails(chartDetails && Object.keys(chartDetails).length > 0
      ? chartDetails
      : {
          activity_name: "Vaccine",
          activity_type: "Vaccine",
          actitivity_id: null,
          mapping_id: chartDetails.field_id || null,
          field_id: chartDetails.field_id || null,
          hasOrder: "false",
        }
    );
  };
  const activityChartToogleHandler = (chartDetails = {}) => {
    console.log("chartDetails", chartDetails);
    setIsActivityChartOpen((prev) => !prev);
    setActivityChartDetails(chartDetails);
  };

  const deleteHandler = async (lab_order_id) => {
    // console.log("Delete clicked", lab_order_id);
    const response = await EmrVisitsService.DeleteOrder(lab_order_id);
    if (response) {
      fetchPhysicalList();
      props.Toast.success("Order deleted successfully");
    }
  };
  const orderLabToogleHandler = (type = "", chartDetails = {}) => {
    if (type === "Lab" || type === "Lab - Point of Care") {
      addLabToogleHandler(chartDetails);
    } else if (type === "Vaccine") {
      addVaccineToogleHandler(chartDetails);
    } else if (type === "Medication - Injectable") {
      const injectionChartDetails = chartDetails && Object.keys(chartDetails).length > 0 
        ? chartDetails 
        : {
            activity_name: "Medication - Injectable",
            activity_type: "Medication - Injectable",
            actitivity_id: null,
            mapping_id: chartDetails.field_id || null,
            field_id: chartDetails.field_id || null,
            lab_order_result_id: null,
            hasOrder: "false"
          };
      activityChartToogleHandler(injectionChartDetails);
    } else if (type === "Medication - Dispensed") {
      const dispensedChartDetails = chartDetails && Object.keys(chartDetails).length > 0 
        ? chartDetails 
        : {
            activity_name: "Medication - Dispensed",
            activity_type: "Medication - Dispensed",
            actitivity_id: null,
            mapping_id: chartDetails.field_id || null,
            field_id: chartDetails.field_id || null,
            lab_order_result_id: null,
            hasOrder: "false"
          };
      activityChartToogleHandler(dispensedChartDetails);
    }
  };
  const statusDetector = (status) => {
    return (
      <div
        class={`badge ${
          status.toLowerCase() == "passed" || status.toLowerCase() == 'normal' || status.toLowerCase() == 'negative' || status.toLowerCase() == 'confirmed negative' || status.toLowerCase() == 'administrated' || status.toLowerCase() == 'dispensed' || status.toLowerCase() == 'administered' || status.toLowerCase() == 'completed'
            ? "sh_badgeSuccess"
            : status.toLowerCase() == "not started" || status.toLowerCase() == 'not administered' 
            ? "sh_badgePending"
            : status.toLowerCase() == "failed" || status.toLowerCase() == 'cancelled' || status.toLowerCase() == 'abnormal' || status.toLowerCase() == 'positive' || status.toLowerCase() == 'confirmed positive' 
            ? "sh_badgeDanger"
            : "sh_badgeWarning"
        } `}
      >
        <span class="pr-1">
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="4"
              cy="4"
              rx="4"
              ry="4"
              fill={`${
                status.toLowerCase() == "passed" || status.toLowerCase() == 'normal' || status.toLowerCase() == 'negative' || status.toLowerCase() == 'confirmed negative' || status.toLowerCase() == 'administrated' || status.toLowerCase() == 'dispensed' || status.toLowerCase() == 'administered' || status.toLowerCase() == 'completed'
                  ? "#0F8647"
                  : status.toLowerCase() == "not started"  
                  ? "#1D2433CC"
                  : status.toLowerCase() == "failed" || status.toLowerCase() == 'cancelled' || status.toLowerCase() == 'abnormal' || status.toLowerCase() == 'positive' || status.toLowerCase() == 'confirmed positive' 
                  ? "#E02D3C"
                  : "#CA8B14"
              }`}
            ></ellipse>
          </svg>
        </span>
        {capitalizeName(status.toLowerCase())}
      </div>
    );
  };
  const [tableRecords, setTableRecords] = useState({
    tableHeaders: tableHeaders,
    tableRows: {
      data: [],
      status: 1000,
    },
    pagination: {
      page: 1,
      perPage: 25,
      totalRecords: 0,
      sort_by: "date",
      sort_order: "asc",
      search: {},
    },
  });
  const [previousTableRecords, setPreviousTableRecords] = useState({
    tableHeaders: tableHeaders,
    tableRows: {
      data: [],
      status: 1000,
    },
    pagination: {
      page: 1,
      perPage: 25,
      totalRecords: 0,
      sort_by: "date",
      sort_order: "asc",
      search: {},
    },
  });

  /** Same idea as PhysicalTab: open chart from Messages/Tasks link without toggle. */
  const openActivityChartFromDeepLink = (chartDetails) => {
    setIsActivityChartOpen(true);
    setActivityChartDetails(chartDetails);
  };

  const tryOpenActivityChartFromRoute = useCallback(() => {
    const searchParams = new URLSearchParams(props.location?.search || "");
    const fromQuery =
      searchParams.get("activityMappingId") || searchParams.get("activity_mapping_id");
    const fromState = props.location?.state?.openChartMappingId;
    const openChartMappingIdRaw = fromState || fromQuery;
    const openChartMappingId =
      openChartMappingIdRaw != null ? String(openChartMappingIdRaw).trim() : "";
    if (!openChartMappingId) {
      return;
    }

    const rows = tableRecords.tableRows?.data || [];
    const match = rows.find(
      (row) =>
        row.emrOrderSource && String(row.emrOrderSource.mapping_id) === openChartMappingId
    );
    if (!match?.emrOrderSource) {
      return;
    }

    const item = match.emrOrderSource;
    openActivityChartFromDeepLink({ ...item, mapping_id: item.mapping_id });

    const navigate = props.navigate;
    if (!navigate) return;
    if (fromState) {
      navigate(props.location.pathname, { replace: true, state: {} });
    }
    if (fromQuery) {
      searchParams.delete("activityMappingId");
      searchParams.delete("activity_mapping_id");
      const nextSearch = searchParams.toString();
      const nextPath = props.location.pathname + (nextSearch ? `?${nextSearch}` : "");
      setTimeout(() => {
        navigate(nextPath, { replace: true, state: props.location?.state || {} });
      }, 0);
    }
  }, [props.location, props.navigate, tableRecords.tableRows?.data]);

  useEffect(() => {
    const sp = new URLSearchParams(props.location?.search || "");
    const hasId =
      sp.get("activityMappingId") ||
      sp.get("activity_mapping_id") ||
      props.location?.state?.openChartMappingId;
    if (!hasId) return;
    requestAnimationFrame(() => tryOpenActivityChartFromRoute());
  }, [props.location?.search, props.location?.state, tryOpenActivityChartFromRoute]);

  useEffect(() => {
    fetchPhysicalList();
    fetchPreviousOrders();
    const employeeId = props?.visitDetails?.employee?.employee_id;
    if (employeeId) {
      fetchEmployeeDetails(employeeId);
    }
    fetchLookups();
  }, []);

  // Refresh orders data when refreshEmrTrigger changes (from Start Over)
  useEffect(() => {
    if (props.refreshEmrTrigger !== undefined && props.refreshEmrTrigger > 0) {
      fetchPhysicalList();
      const employeeId = props?.visitDetails?.employee?.employee_id;
      if (employeeId) {
        fetchEmployeeDetails(employeeId);
      }
    }
  }, [props.refreshEmrTrigger]);

  const fetchPhysicalList = async (query = {}) => {
    try {
      const visitId = props.visit_id;
      const queryString = toQueryString({
        ...tableRecords.pagination,
        ...query,
      });

      const response = await EmrVisitsService.ListOrders(visitId);
      let ready = { total: 0, labs: 0, xrays: 0, others: 0 };
      let pending = { total: 0, labs: 0, xrays: 0, others: 0 };
      let completed = { total: 0, labs: 0, xrays: 0, others: 0 }
      const orders = response.orders || [];
      console.log("response", response);
      const counts = response.counts || {};
      orders.forEach((order) => {
        const activityStatus = (order.activity_status || order.status || "").toLowerCase();
        const chartStatus = (order.status || "").toLowerCase();
        const category = (order.category || "").toUpperCase();
        let targetCard;
        if (activityStatus === "not started") {
          targetCard = ready;
        } else if (activityStatus === "completed" || chartStatus === "passed" || chartStatus === "failed" || chartStatus === "dispensed" || chartStatus === "administered" || chartStatus === "administrated") {
          targetCard = completed;
        } else {
          targetCard = pending;
        }
        targetCard.total  = targetCard.total+ 1;
        if (category === "LAB") {
          targetCard.labs = targetCard.labs + 1;
        } else if (category === "X_RAY") {
          targetCard.xrays = targetCard.xrays + 1;
        } else {
         targetCard.others += 1;
        }
      });
      setOrderCounts({
        ready,
        pending,
        completed,
      });
      const tableData = response.orders.map((item, index) => ({
        rowId: item.lab_order_result_id,
        emrOrderSource: item,
        data: {
          emr_activity_name: {
            value: (() => {
              // For Dispensed and Injection, show field name (emr_field_label) when available
              const displayName = (item.activity_type === "Medication - Dispensed" || item.activity_type === "Medication - Injectable") && item.emr_field_label
                ? item.emr_field_label
                : (item.activity_name || "-");
              return (
                <div 
                  style={{ whiteSpace: 'normal', wordBreak: 'break-word', minWidth: '200px' }} 
                  title={displayName}
                >
                  {displayName}
                </div>
              );
            })()
          },
          emr_activity_type: item.activity_type,
          // status: item.status || "-",
          // status: {
          //   value: (
          //     <a className="px-1" title={item.status || "-"}>
          //       <Icons
          //         fontSize={"15px"}
          //         // type={`New${getOverAllStatusIcon(visit?.overall_status)}`}
          //         type={`${getOverAllStatusIcon(item.status)}`}
          //       />
          //     </a>
          //   ),
          // },
          status_badge: {
            value: (
              <a className="forTable_textEllipsis" title={item.activity_status || item.status || "-"}>
                {statusDetector(item.activity_status || item.status || "-")}
              </a>
            ),
          },
          labeled_status: {
            value: (
              <a className="forTable_textEllipsis" title={item.status || "-"}>
                {statusDetector(item.status || "-")}
              </a>
            ),
          },
          timePlaced: item.created_at || "-",
          totalTime: item.total_time || "-",
          action: [
            (item.activity_type === "Lab" && item.hasOrder === "false") ||
            (item.activity_type === "Vaccine" && item.hasOrder === "false") ||
            (item.activity_type === "Medication - Injectable" && item.hasOrder === "false") ||
            (item.activity_type === "Medication - Dispensed" && item.hasOrder === "false")
              ? {
                  className: "btn btn-icon btn-transparent-dark",
                  iconType: "AddPlus",
                  title: "Add Order",
                  label: "",
                  acl: "any",
                  clickHandler: () =>
                    orderLabToogleHandler(item.activity_type, item),
                }
              : {
                  className: "btn btn-icon btn-transparent-dark",
                  iconType: "ActivityChart",
                  acl: "any",
                  title: "Chart",
                  clickHandler: () =>
                    activityChartToogleHandler({
                      ...item,
                      mapping_id: item.mapping_id,
                    }),
                },
                // Only show print option for Lab orders that have been created
                ...(item.activity_type === "Lab" && item.hasOrder === "true" ? [{
                  className: 'btn btn-icon btn-transparent-dark pl-1 pr-1',
                  title: 'Print',
                  acl:'any',
                  children:(
                    <>
                        <span className="dropdown dropdown-toggle position-static noArrow" data-bs-toggle="dropdown">
                         <svg fill="#000000" height="16" width="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64">	<path d="M57.7881012,14.03125H52.5v-8.0625c0-2.2091999-1.7909012-4-4-4h-33c-2.2091999,0-4,1.7908001-4,4v8.0625H6.2119002		C2.7871001,14.03125,0,16.8183498,0,20.2431507V46.513649c0,3.4248009,2.7871001,6.2119026,6.2119002,6.2119026h2.3798995		c0.5527,0,1-0.4472008,1-1c0-0.5527-0.4473-1-1-1H6.2119002C3.8896,50.7255516,2,48.8359489,2,46.513649V20.2431507		c0-2.3223,1.8896-4.2119007,4.2119002-4.2119007h51.5762024C60.1102982,16.03125,62,17.9208508,62,20.2431507V46.513649		c0,2.3223-1.8897018,4.2119026-4.2118988,4.2119026H56c-0.5527992,0-1,0.4473-1,1c0,0.5527992,0.4472008,1,1,1h1.7881012		C61.2128983,52.7255516,64,49.9384499,64,46.513649V20.2431507C64,16.8183498,61.2128983,14.03125,57.7881012,14.03125z		 M13.5,5.96875c0-1.1027999,0.8971996-2,2-2h33c1.1027985,0,2,0.8972001,2,2v8h-37V5.96875z"/>	<path d="M44,45.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,47.0302505,20,47.0302505h24		c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,45.0322495,44,45.0322495z"/>	<path d="M44,52.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,54.0302505,20,54.0302505h24		c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,52.0322495,44,52.0322495z"/>	<circle cx="7.9590998" cy="21.8405495" r="2"/>	<circle cx="14.2856998" cy="21.8405495" r="2"/>	<circle cx="20.6121998" cy="21.8405495" r="2"/>	<path d="M11,62.03125h42v-26H11V62.03125z M13.4036999,38.4349518h37.1925964v21.1925964H13.4036999V38.4349518z"/></svg>
                        </span>
                        <div className="dropdown-menu dropdown-menu-left shadow" aria-labelledby="userDropdown">
                            <div className="dropdown-item" href="#" onClick={()=>printlabel(item,"print_label_1x3")}>
                              Print Lab Label 1 ⅛ X 3 ½
                            </div>
                            <div className="dropdown-item" href="#" onClick={()=>printlabel(item,"print_label_2x3")}>
                              Print Lab Label 2 X 3.8
                            </div>
                            <div className="dropdown-item" href="#" onClick={()=>printlabel(item,"lab_report")}>
                              Print Lab Report
                            </div>
                            <div className="dropdown-item" href="#" onClick={()=>printlabel(item,"lab_requisition")}>
                              Print Lab Requisition
                            </div>
                          </div>
                    </>
                  )
                 }] : []),   
                 // Only show print option for Vaccine orders that have been created
                ...(item.activity_type === "Vaccine" && item.hasOrder === "true" ? [{
                  className: 'btn btn-icon btn-transparent-dark pl-1 pr-1',
                  title: 'Print',
                  acl: 'any',
                  children: (
                    <>
                      <svg onClick={() => printVaccineLabel(item)} fill="#000000" height="16" width="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64"><path d="M57.7881012,14.03125H52.5v-8.0625c0-2.2091999-1.7909012-4-4-4h-33c-2.2091999,0-4,1.7908001-4,4v8.0625H6.2119002		C2.7871001,14.03125,0,16.8183498,0,20.2431507V46.513649c0,3.4248009,2.7871001,6.2119026,6.2119002,6.2119026h2.3798995		c0.5527,0,1-0.4472008,1-1c0-0.5527-0.4473-1-1-1H6.2119002C3.8896,50.7255516,2,48.8359489,2,46.513649V20.2431507		c0-2.3223,1.8896-4.2119007,4.2119002-4.2119007h51.5762024C60.1102982,16.03125,62,17.9208508,62,20.2431507V46.513649		c0,2.3223-1.8897018,4.2119026-4.2118988,4.2119026H56c-0.5527992,0-1,0.4473-1,1c0,0.5527992,0.4472008,1,1,1h1.7881012		C61.2128983,52.7255516,64,49.9384499,64,46.513649V20.2431507C64,16.8183498,61.2128983,14.03125,57.7881012,14.03125z		 M13.5,5.96875c0-1.1027999,0.8971996-2,2-2h33c1.1027985,0,2,0.8972001,2,2v8h-37V5.96875z"/><path d="M44,45.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,47.0302505,20,47.0302505h24		c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,45.0322495,44,45.0322495z"/><path d="M44,52.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,54.0302505,20,54.0302505h24		c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,52.0322495,44,52.0322495z"/><circle cx="7.9590998" cy="21.8405495" r="2"/><circle cx="14.2856998" cy="21.8405495" r="2"/><circle cx="20.6121998" cy="21.8405495" r="2"/><path d="M11,62.03125h42v-26H11V62.03125z M13.4036999,38.4349518h37.1925964v21.1925964H13.4036999V38.4349518z"/></svg>
                    </>
                  )
                }] : []),
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Remove",
              acl: "any",
              title: "Delete",
              isDelete: true,
              clickHandler: () => deleteHandler(item.lab_order_result_id),
            },
          ],
        },
      }));

      setTableRecords((prevState) => ({
        ...prevState,
        tableRows: {
          data: tableData,
          status: 200,
        },
        pagination: {
          ...prevState.pagination,
          totalRecords: isSet(response) ? response.length : 0,
          page: query.page || prevState.pagination.page,
          perPage: query.perPage || prevState.pagination.perPage,
        },
      }));

      console.log("tableData", tableData);
    } catch (err) {
      console.error("Error fetching physical list:", err);
    }
  };

  const fetchPreviousOrders = async (query = {}) => {
    try {
      const visitId = props.visit_id;
      const response = await EmrVisitsService.ListPreviousOrders(visitId);
      const orders = response?.orders || [];

      const tableData = orders.map((item) => ({
        rowId: item.lab_order_result_id,
        data: {
          emr_activity_name: {
            value: (() => {
              const displayName =
                (item.activity_type === "Medication - Dispensed" ||
                  item.activity_type === "Medication - Injectable") &&
                item.emr_field_label
                  ? item.emr_field_label
                  : item.activity_name || "-";
              return (
                <div
                  style={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    minWidth: "200px",
                  }}
                  title={displayName}
                >
                  {displayName}
                </div>
              );
            })(),
          },
          emr_activity_type: item.activity_type,
          status_badge: {
            value: (
              <a
                className="forTable_textEllipsis"
                title={item.activity_status || item.status || "-"}
              >
                {statusDetector(item.activity_status || item.status || "-")}
              </a>
            ),
          },
          labeled_status: {
            value: (
              <a
                className="forTable_textEllipsis"
                title={item.status || "-"}
              >
                {statusDetector(item.status || "-")}
              </a>
            ),
          },
          timePlaced: item.created_at || "-",
          totalTime: item.total_time || "-",
          action: [
            {
              className: "btn btn-icon btn-transparent-dark no-access",
              iconType: "ActivityChart",
              acl: "any",
              title: "View",
              disabled: true,
              href: null,
              clickHandler: () => {}, // visible but does nothing
            },
            ...(item.activity_type === "Lab" && item.hasOrder === "true"
              ? [
                  {
                    className: "btn btn-icon btn-transparent-dark pl-1 pr-1",
                    title: "Print",
                    acl: "any",
                    children: (
                      <>
                        <span className="dropdown dropdown-toggle position-static noArrow" data-bs-toggle="dropdown">
                          <svg fill="#000000" height="16" width="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64">
                            <path d="M57.7881012,14.03125H52.5v-8.0625c0-2.2091999-1.7909012-4-4-4h-33c-2.2091999,0-4,1.7908001-4,4v8.0625H6.2119002 C2.7871001,14.03125,0,16.8183498,0,20.2431507V46.513649c0,3.4248009,2.7871001,6.2119026,6.2119002,6.2119026h2.3798995 c0.5527,0,1-0.4472008,1-1c0-0.5527-0.4473-1-1-1H6.2119002C3.8896,50.7255516,2,48.8359489,2,46.513649V20.2431507 c0-2.3223,1.8896-4.2119007,4.2119002-4.2119007h51.5762024C60.1102982,16.03125,62,17.9208508,62,20.2431507V46.513649 c0,2.3223-1.8897018,4.2119026-4.2118988,4.2119026H56c-0.5527992,0-1,0.4473-1,1c0,0.5527992,0.4472008,1,1,1h1.7881012 C61.2128983,52.7255516,64,49.9384499,64,46.513649V20.2431507C64,16.8183498,61.2128983,14.03125,57.7881012,14.03125z M13.5,5.96875c0-1.1027999,0.8971996-2,2-2h33c1.1027985,0,2,0.8972001,2,2v8h-37V5.96875z" />
                            <path d="M44,45.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,47.0302505,20,47.0302505h24 c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,45.0322495,44,45.0322495z" />
                            <path d="M44,52.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,54.0302505,20,54.0302505h24 c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,52.0322495,44,52.0322495z" />
                            <circle cx="7.9590998" cy="21.8405495" r="2" /><circle cx="14.2856998" cy="21.8405495" r="2" /><circle cx="20.6121998" cy="21.8405495" r="2" />
                            <path d="M11,62.03125h42v-26H11V62.03125z M13.4036999,38.4349518h37.1925964v21.1925964H13.4036999V38.4349518z" />
                          </svg>
                        </span>
                        <div className="dropdown-menu dropdown-menu-left shadow" aria-labelledby="userDropdown">
                          <div className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); printlabel(item, "print_label_1x3"); }}>Print Lab Label 1 ⅛ X 3 ½</div>
                          <div className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); printlabel(item, "print_label_2x3"); }}>Print Lab Label 2 X 3.8</div>
                          <div className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); printlabel(item, "lab_report"); }}>Print Lab Report</div>
                          <div className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); printlabel(item, "lab_requisition"); }}>Print Lab Requisition</div>
                        </div>
                      </>
                    ),
                  },
                ]
              : []),
            ...(item.activity_type === "Vaccine" && item.hasOrder === "true"
              ? [
                  {
                    className: "btn btn-icon btn-transparent-dark pl-1 pr-1",
                    title: "Print",
                    acl: "any",
                    children: (
                      <svg onClick={() => printVaccineLabel(item)} fill="#000000" height="16" width="16" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <path d="M57.7881012,14.03125H52.5v-8.0625c0-2.2091999-1.7909012-4-4-4h-33c-2.2091999,0-4,1.7908001-4,4v8.0625H6.2119002 C2.7871001,14.03125,0,16.8183498,0,20.2431507V46.513649c0,3.4248009,2.7871001,6.2119026,6.2119002,6.2119026h2.3798995 c0.5527,0,1-0.4472008,1-1c0-0.5527-0.4473-1-1-1H6.2119002C3.8896,50.7255516,2,48.8359489,2,46.513649V20.2431507 c0-2.3223,1.8896-4.2119007,4.2119002-4.2119007h51.5762024C60.1102982,16.03125,62,17.9208508,62,20.2431507V46.513649 c0,2.3223-1.8897018,4.2119026-4.2118988,4.2119026H56c-0.5527992,0-1,0.4473-1,1c0,0.5527992,0.4472008,1,1,1h1.7881012 C61.2128983,52.7255516,64,49.9384499,64,46.513649V20.2431507C64,16.8183498,61.2128983,14.03125,57.7881012,14.03125z M13.5,5.96875c0-1.1027999,0.8971996-2,2-2h33c1.1027985,0,2,0.8972001,2,2v8h-37V5.96875z" />
                        <path d="M44,45.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,47.0302505,20,47.0302505h24 c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,45.0322495,44,45.0322495z" />
                        <path d="M44,52.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,54.0302505,20,54.0302505h24 c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,52.0322495,44,52.0322495z" />
                        <circle cx="7.9590998" cy="21.8405495" r="2" /><circle cx="14.2856998" cy="21.8405495" r="2" /><circle cx="20.6121998" cy="21.8405495" r="2" />
                        <path d="M11,62.03125h42v-26H11V62.03125z M13.4036999,38.4349518h37.1925964v21.1925964H13.4036999V38.4349518z" />
                      </svg>
                    ),
                  },
                ]
              : []),
          ],
        },
      }));

      setPreviousTableRecords((prevState) => ({
        ...prevState,
        tableRows: {
          data: tableData,
          status: 200,
        },
        pagination: {
          ...prevState.pagination,
          totalRecords: orders.length,
        },
      }));
    } catch (err) {
      console.error("Error fetching previous orders history:", err);
    }
  };

  const fetchLookups = async () => {
    try {
      const [chartResult, shippingService] = await Promise.all([
        LookupService.getLookupByKey("chart_result"),
        LookupService.getLookupByKey("shipping_service"),
      ]);

      // Build dropdown options
      const shippingServiceOptions = [{ label: "-None-", value: "" }];
      shippingService.forEach((item) => {
        shippingServiceOptions.push({
          label: item.value,
          value: item.value,
        });
      });

      const chartResultOptions = [{ label: "-None-", value: "" }];
      chartResult.forEach((item) => {
        chartResultOptions.push({
          label: item.value,
          value: item.value,
        });
      });

      // ✅ Update state
      setLookupsOptions({
        shippingService: shippingServiceOptions,
        chartResult: chartResultOptions,
      });

      console.log("Lookup options loaded", {
        shippingServiceOptions,
        chartResultOptions,
      });
    } catch (error) {
      console.error("Error fetching lookup options:", error);
    }
  };

  const printlabel = async (data, type, labelName = 'lab') => {
    const queryfilters = {
      label_type: type,
      visit_id: data.visit_id || props.visit_id,
    };
    let printData;
    console.log("data", data);
    // Use data.id which is the snap_visit_lab id
    const labId = data.id;
    if (type === 'lab_report') {
      printData = await PatientChartsService.getLaboratoryReport(null, queryfilters, labId);
    } else if (type === 'lab_requisition') {
      printData = await PatientChartsService.getLabRequisition(null, queryfilters, labId);
    } else {
      printData = await PatientChartsService.getPrintLabel(null, queryfilters, labId);
    }
    const pdfData = {
      file_content: printData,
      original_name: `${labelName}`,
      mime_type: 'application/pdf'
    };
    FileManagerService.printPdf(pdfData);
  };

  const printVaccineLabel = async (item, pdfname = 'vaccineResult') => {
    const response = await PatientChartsService.getVaccinePDF(item.id);
    console.log("response", response);
    const pdfData = {
      file_content: response,
      original_name: `${pdfname}`,
      mime_type: 'application/pdf'
    };
    FileManagerService.printPdf(pdfData);
  };

  const fetchEmployeeDetails = async (employeeId) => {
    try {
      if (employeeId) {
        props.Loader(true); // ✅ use props instead of this.props
        const data = await EmployeeService.getEmployee(employeeId);
        setEmployeeDetails(data); // ✅ use setState hook
        props.Loader(false);
      }
    } catch (error) {
      props.Loader(false);
      console.error("Error fetching employee details:", error);
    }
  };

  return (
    <>
      {isLabModelOpen ? (
        <ActivityCharts
          chartDetails={activityChartDetails}
          isOpen={isLabModelOpen}
          visitDetails={props.visitDetails}
          fetchVisitDetails={() => fetchPhysicalList()}
          stateList={props.stateList}
          employeeDetails={employeeDetails}
          lookupsOptions={lookupsOptions}
          companyDetails={props.visitDetails?.company}
          toogleHanlder={addLabToogleHandler}
          Toast={props.Toast}
          Loader={props.Loader}
          employeeId={props.visitDetails?.employee?.employee_id}
          fetchEmployeeDetails={fetchEmployeeDetails}
        />
      ) : (
        ""
      )}
      {isVaccineModelOpen ? (
        <ActivityCharts
        chartDetails={activityChartDetails}
        isOpen={isVaccineModelOpen}
        visitDetails={props.visitDetails}
        fetchVisitDetails={() => fetchPhysicalList()}
        stateList={props.stateList}
        employeeDetails={employeeDetails}
        lookupsOptions={lookupsOptions}
        companyDetails={props.visitDetails?.company}
        toogleHanlder={addVaccineToogleHandler}
        Toast={props.Toast}
        Loader={props.Loader}
        employeeId={props.visitDetails?.employee?.employee_id}
        fetchEmployeeDetails={fetchEmployeeDetails}
        />
      ) : (
        ""
      )}
      {isActivityChartOpen ? (
        <ActivityCharts
          chartDetails={activityChartDetails}
          isOpen={isActivityChartOpen}
          visitDetails={props.visitDetails}
          fetchVisitDetails={() => fetchPhysicalList()}
          stateList={props.stateList}
          employeeDetails={employeeDetails}
          lookupsOptions={lookupsOptions}
          companyDetails={props.visitDetails.company}
          toogleHanlder={activityChartToogleHandler}
        />
      ) : (
        ""
      )}
      <div className="row">
         {/* status bar */}
        <div
          className="sh_cardHeader rounded-2"
          style={{
            background: "linear-gradient(90deg, #FFF7DC 0%, #F7E9E5 100%)",
          }}
        >
          <div className="d-flex justify-content-center">
            <div className="form-group d-flex mb-0 justify-content-between align-items-center">
              <EmrStatusBar visitDetails={props.visitDetails} />
            </div>
          </div>
        </div>
        {/* Visits page cards for orders and results */}
        <div className="sh_cardHeader px-0">
          <div className="row mb-2">
            <div className="col-lg-4 col-md-6 py-1 col-6">
              <div className="d-flex align-items-center justify-content-between sh_statusIndicatorbox blue-orichid px-4 py-3 rounded-4 shadow-sm">
                {/* Left Section */}
                <div className="d-flex align-items-center gap-3">
                  <span
                    className="sh_statusIndicator bg-white "
                    style={{ width: "56px", height: "56px" }}
                  >
                    {/* Your SVG icon */}
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M7 12H10"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7 16H8"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.9749 14.3V12.6C18.9749 11.9925 18.4824 11.5 17.8749 11.5H15.1249C14.5174 11.5 14.0249 11.9925 14.0249 12.6V14.3"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <rect
                        x="11"
                        y="14.3"
                        width="11"
                        height="7.7"
                        rx="1.98"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.25 18H17.75"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.5 19.25V16.75"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 21H5.5C4.11929 21 3 19.8807 3 18.5V8.37167C3.00001 7.57602 3.31608 6.81296 3.8787 6.25035L6.25038 3.87868C6.81299 3.31607 7.57605 3 8.3717 3H15.5C16.8807 3 18 4.11929 18 5.5V8"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3.02344 8.00006H6.49985C7.32827 8.00006 7.99985 7.32849 7.99985 6.50006V3.02368"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                 {/* center section */}
                  <div>
                    <p className="mb-1 fw-medium text-dark">Ready to Process</p>
                    <h3 className="fw-bold mb-0">{orderCounts.ready.total}</h3>
                  </div>

                {/* Right Section */}
                <div className="text-dark">
                   <p className="mb-1 small order-row">
                    <span className="order-label">Labs</span>
                    <strong className="order-value">{orderCounts.ready.labs}</strong>
                  </p>
                  <p className="mb-1 small order-row">
                    <span className="order-label">Xrays</span>
                    <strong className="order-value">{orderCounts.ready.xrays}</strong>
                  </p>
                  <p className="mb-0 small order-row">
                    <span className="order-label">Others</span>
                    <strong className="order-value">{orderCounts.ready.others}</strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 py-1 col-6">
              <div className="d-flex align-items-center justify-content-between sh_statusIndicatorbox pale-purple px-4 py-3 rounded-4 shadow-sm">
                {/* Left Section */}
                <div className="d-flex align-items-center gap-3">
                  <span
                    className="sh_statusIndicator bg-white"
                    style={{ width: "56px", height: "56px" }}
                  >
                    {/* SVG Icon */}
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.0052 16.4974C13.0537 17.4984 13.4528 18.4505 14.1327 19.1869C14.6757 19.8176 15.3236 20.3497 16.0479 20.7598C16.6786 21.1116 17.4515 21.0889 18.0604 20.7005C18.7169 20.2809 19.3071 19.7657 19.8117 19.1721C20.5041 18.4432 20.9264 17.4994 21.0086 16.4974C21.0134 15.9013 20.7905 15.3258 20.3854 14.8884C19.9961 14.4643 19.4483 14.2208 18.8726 14.2161C18.1498 14.1656 17.4513 14.4879 17.0207 15.0706L17.007 15.0907L16.9931 15.0706C16.6013 14.5193 15.9609 14.1989 15.2847 14.2161C14.6768 14.2058 14.0907 14.4429 13.6609 14.873C13.2311 15.3031 12.9944 15.8894 13.0052 16.4974Z"
                        stroke="#323232"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.0059 10.0044H17.0075"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.00293 9.7302L7.92231 10.5585L9.77308 8.89185"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.0044 21.009H8.00355C5.24097 21.009 3.00146 18.7695 3.00146 16.0069V8.00355C3.00146 5.24097 5.24097 3.00146 8.00355 3.00146H16.0069C18.7695 3.00146 21.009 5.24097 21.009 8.00355V11.0048"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.00293 14.7324L7.92231 15.5607L9.77308 13.894"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  </div>
                    {/* center section */}
                  <div>
                    <p className="mb-1 fw-medium text-dark">Pending Results</p>
                    <h3 className="fw-bold mb-0">
                      {orderCounts.pending.total}
                    </h3>
                  </div>

                {/* Right Section */}
                <div className="text-dark">
                  <p className="mb-1 small order-row">
                    <span className="order-label">Labs</span>
                    <strong className="order-value">{orderCounts.pending.labs}</strong>
                  </p>
                  <p className="mb-1 small order-row">
                    <span className="order-label">Xrays</span>
                    <strong className="order-value">{orderCounts.pending.xrays}</strong>
                  </p>
                  <p className="mb-0 small order-row">
                    <span className="order-label">Others</span>
                    <strong className="order-value">{orderCounts.pending.others}</strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 py-1 col-6">
              <div className="d-flex align-items-center justify-content-between sh_statusIndicatorbox linear_gradient px-4 py-3 rounded-4 shadow-sm">
                {/* Left Section */}
                <div className="d-flex align-items-center gap-3">
                  <span
                    className="sh_statusIndicator bg-white"
                    style={{ width: "56px", height: "56px" }}
                  >
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 18H14"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.979 3H7.021C6.469 3 6.021 3.448 6.021 4V6.378C6.021 6.799 6.154 7.21 6.401 7.551L9.621 12L6.401 16.449C6.154 16.79 6.021 17.201 6.021 17.622V20C6.021 20.552 6.469 21 7.021 21H16.978C17.53 21 17.978 20.552 17.978 20V17.658C17.978 17.214 17.83 16.783 17.558 16.432L14.121 12L17.559 7.567C17.831 7.216 17.979 6.785 17.979 6.341V4C17.979 3.448 17.531 3 16.979 3Z"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                {/* center section */}
                  <div>
                    <p className="mb-1 fw-medium text-dark">Completed</p>
                    <h3 className="fw-bold mb-0">
                      {orderCounts.completed.total}
                    </h3>
                  </div>

                {/* Right Section */}
                <div className="text-dark">
                  <p className="mb-1 small order-row">
                    <span className="order-label">Labs</span>
                    <strong className="order-value">{orderCounts.completed.labs}</strong>
                  </p>
                  <p className="mb-1 small order-row">
                    <span className="order-label">Xrays</span>
                    <strong className="order-value">{orderCounts.completed.xrays}</strong>
                  </p>
                  <p className="mb-0 small order-row">
                    <span className="order-label">Others</span>
                    <strong className="order-value">{orderCounts.completed.others}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="d-flex flex-column flex-md-row gap-3"
          style={{ alignItems: "stretch" }}
        >
          {aiSuggestionsEnabled && (
            <div
              className="mb-3"
              style={{
                flex: "0 0 25%",
                maxWidth: "25%",
              }}
            >
              <div className="card sh_basecard" style={{ height: "650px" }}>
                <div
                  className="card-body px-2 py-2 sh_basecardBody"
                  style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}
                >
                  <div
                    className="ai-predictive-card d-flex w-100 align-items-center justify-content-between mb-2"
                    style={{ ...aiPredictiveCardStyle, cursor: "default" }}
                  >
                    <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
                      <span className="ai-predictive-icon d-flex align-items-center justify-content-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.0017 16.0019C12.0017 13.7918 13.7933 12.0002 16.0033 12.0002C13.7933 12.0002 12.0017 10.2086 12.0017 7.99854C12.0017 10.2086 10.2101 12.0002 8 12.0002C10.2101 12.0002 12.0017 13.7918 12.0017 16.0019Z"
                            stroke="url(#paint0_linear_ai_orders_card)"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M21.0036 12.0001C21.0036 16.9727 16.9725 21.0038 11.9998 21.0038C7.02721 21.0038 2.99609 16.9727 2.99609 12.0001C2.99609 7.02745 7.02721 2.99634 11.9998 2.99634"
                            stroke="url(#paint1_linear_ai_orders_card)"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.0052 7.99835C19.0052 6.34081 20.3489 4.9971 22.0064 4.9971C20.3489 4.9971 19.0052 3.65339 19.0052 1.99585C19.0052 3.65339 17.6615 4.9971 16.0039 4.9971C17.6615 4.9971 19.0052 6.34081 19.0052 7.99835Z"
                            stroke="url(#paint2_linear_ai_orders_card)"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_ai_orders_card"
                              x1="16.0033"
                              y1="12.0002"
                              x2="8"
                              y2="12.0002"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0.0625" stopColor="#9AA1FF" />
                              <stop offset="1" stopColor="#4474E6" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_ai_orders_card"
                              x1="21.0036"
                              y1="12.0001"
                              x2="2.99609"
                              y2="12.0001"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0.0625" stopColor="#9AA1FF" />
                              <stop offset="1" stopColor="#4474E6" />
                            </linearGradient>
                            <linearGradient
                              id="paint2_linear_ai_orders_card"
                              x1="22.0064"
                              y1="4.99709"
                              x2="16.0039"
                              y2="4.99709"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0.0625" stopColor="#9AA1FF" />
                              <stop offset="1" stopColor="#4474E6" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </span>
                      <p
                        className="mb-0 text-dark font-weight-bold"
                        style={{ ...aiPredictiveTitleStyle, lineHeight: 1.2 }}
                      >
                        AI - Predictive Charting
                      </p>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <button
                        type="button"
                        className="btn btn-light sh_btnlight d-flex align-items-center justify-content-center"
                        aria-label="Reload suggestions"
                        title="Reload suggestions"
                        onClick={handleOrdersReloadSuggestions}
                        style={{ width: "34px", height: "34px", padding: 0 }}
                      >
                        <Icons type={"ReloadSuggestions"} size={16} color={"#4B5563"} />
                      </button>
                      <span
                        className="ai-secondary-nav-chevron d-flex align-items-center justify-content-center"
                        style={aiChevronStyle}
                      >
                        <svg fill="#000000" width="20" height="20" viewBox="-0.15 -0.225 0.72 0.72">
                          <path d="m0.212 0.085 -0.148 0.148A0.03 0.03 0 0 1 0.021 0.191L0.191 0.021a0.03 0.03 0 0 1 0.042 0l0.17 0.17a0.03 0.03 0 0 1 -0.042 0.042z" />
                        </svg>
                      </span>
                    </div>
                  </div>

                  <div
                    className="ai-predictive-card mt-2"
                    style={{ ...aiPredictiveCardStyle, overflow: "visible", flex: 1, display: "flex", flexDirection: "column" }}
                  >
                      <div className="ai-predictive-list flex-grow-1" style={aiPredictiveListStyle}>
                        {ordersAiLoading && (
                          <div className="d-flex align-items-center justify-content-center py-2 text-center flex-column">
                            <div className="d-flex align-items-center justify-content-center mb-1">
                              <span
                                style={{
                                  width: 20,
                                  height: 20,
                                  borderRadius: "50%",
                                  border: "3px solid rgba(126, 224, 255, 0.3)",
                                  borderTopColor: "#7EE0FF",
                                  animation: "aiSpin 0.8s linear infinite",
                                  display: "inline-block",
                                  marginRight: 8,
                                }}
                              />
                              <span style={{ color: "#4B5563", fontSize: "13px", fontWeight: 500 }}>
                                Generating AI orders...
                              </span>
                            </div>
                            <span style={{ color: "#6B7280", fontSize: "12px" }}>
                              {ordersAiLoadingMessages[ordersAiLoadingStep]}
                            </span>
                          </div>
                        )}

                        {ordersAiError && !ordersAiLoading && (
                          <div
                            style={{
                              color: "#ff6b6b",
                              fontSize: "13px",
                              fontWeight: "500",
                              padding: "8px",
                              backgroundColor: "rgba(255, 107, 107, 0.1)",
                              borderRadius: "8px",
                            }}
                          >
                            {ordersAiError}
                          </div>
                        )}

                        {!ordersAiLoading &&
                          !ordersAiError &&
                          ordersAiSuggestions.length === 0 && (
                            <div
                              className="d-flex align-items-center justify-content-center py-2 text-muted"
                              style={{ fontSize: "13px" }}
                            >
                              No suggestions available.
                            </div>
                          )}

                        {!ordersAiLoading &&
                          !ordersAiError &&
                          ordersAiSuggestions.length > 0 &&
                          ordersAiSuggestions.map((item, index) => (
                            <div
                              key={item.id}
                              className={`ai-predictive-item d-flex align-items-start justify-content-between ${
                                index === ordersAiSuggestions.length - 1 ? "mb-0" : "mb-2"
                              }`}
                              style={{
                                opacity: item.isAccepted ? 0.6 : 1,
                                textDecoration: item.isAccepted ? "line-through" : "none",
                                borderBottom:
                                  index === ordersAiSuggestions.length - 1
                                    ? "none"
                                    : "1px solid #E5E7EB",
                                paddingBottom: index === ordersAiSuggestions.length - 1 ? 0 : 8,
                              }}
                            >
                              <div className="me-3">
                                <p
                                  className="mb-1 text-uppercase"
                                  style={{
                                    fontSize: "13px",
                                    letterSpacing: "0.5px",
                                    color: "#6B7280",
                                    fontWeight: 600,
                                  }}
                                >
                                  {item.category}
                                </p>
                                <p className="mb-1 font-weight-bold" style={aiPredictiveCodeStyle}>
                                  {item.title}
                                </p>
                                <p className="mb-0 text-muted small" style={aiPredictiveDescStyle}>
                                  {item.confidenceLabel}
                                </p>
                              </div>
                              <div style={{ paddingTop: "6px" }}>
                                <input
                                  type="checkbox"
                                  checked={item.isAccepted}
                                  disabled={item.isAccepted}
                                  onChange={() => openOrderAiPreview(item)}
                                />
                              </div>
                            </div>
                          ))}
                        <style>{`
                          @keyframes aiSpin {
                            from { transform: rotate(0deg) }
                            to { transform: rotate(360deg) }
                          }
                        `}</style>
                      </div>
                      <div className="d-flex justify-content-end mt-2">
                        <small style={{ color: "#6B7280", fontSize: "12px" }}>
                          Click a suggestion checkbox to review and apply.
                        </small>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          )}

          <div className="flex-grow-1">
            <div className="card sh_basecard cardhtmd" style={{ height: "650px" }}>
              <div className="card-header p-2 sh_basecardHeader">
                <div className="d-flex w-100 justify-content-between align-items-center">
                  Order and Result
                  <div className="d-flex flex-column">
                    <div className="progress w-100 sh_emrprogressbar">
                      <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: "30%" }}
                        aria-valuenow="30"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      />
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="p2-strong pr-1">Pending Results</span>
                      <p className="p3-light mb-0">07/03/2025, 10:27 AM</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body p-0 my-2 px-0 sh_basecardBody">
                <TableGrid {...tableRecords} />
              </div>
            </div>
          </div>
        </div>

        {showOrderAiPreviewModal && selectedOrderSuggestion && (
          <Modal
            show={showOrderAiPreviewModal}
            onHide={() => {
              setShowOrderAiPreviewModal(false);
              setSelectedOrderSuggestion(null);
            }}
            centered
            dialogClassName="orders-ai-preview-modal"
          >
            <style>{`
              .orders-ai-preview-modal { max-width: 650px; width: 100%; }
              .orders-ai-preview-modal .modal-content {
                max-height: 85vh;
                display: flex;
                flex-direction: column;
              }
              .orders-ai-preview-modal .modal-body { padding: 8px 12px; overflow-y: auto; }
              .orders-ai-preview-modal .ai-preview-scroll {
                max-height: none;
                overflow: visible;
              }
            `}</style>
            <Modal.Header closeButton>
              <Modal.Title>
                <h6 className="mb-0">AI Order Preview</h6>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="card sh_basecard mb-0">
                <div className="card-body p-2 sh_basecardBody ai-preview-scroll">
                  <p className="mb-2" style={{ fontSize: 13, color: '#4B5563' }}>
                    Read-only preview. Click <strong>Save</strong> to place this order.
                  </p>
                  <p className="mb-1" style={{ fontSize: 13, color: "#000000" }}>
                    <strong>Order Name:</strong> {selectedOrderSuggestion.title}
                  </p>
                  <p className="mb-1" style={{ fontSize: 13, color: "#000000" }}>
                    <strong>Category:</strong> {selectedOrderSuggestion.category}
                  </p>
                  <div className="mt-2" style={{ fontSize: 13, color: "#000000" }}>
                    {getOrderPreviewSections(selectedOrderSuggestion).length > 0 ? (
                      getOrderPreviewSections(selectedOrderSuggestion).map((section, idx) => (
                        <p className="mb-1" key={`order-preview-section-${idx}`}>
                          <strong>{section.label}:</strong> {section.value}
                        </p>
                      ))
                    ) : (
                      <p className="mb-1">No rationale provided.</p>
                    )}
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn sh_btnlight"
                onClick={() => {
                  setShowOrderAiPreviewModal(false);
                  setSelectedOrderSuggestion(null);
                }}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary sh_btnprimary"
                onClick={async () => {
                  await handleOrdersApplySuggestion(selectedOrderSuggestion);
                }}
              >
                Place Order
              </button>
            </Modal.Footer>
          </Modal>
        )}

        <div
          className="d-flex flex-column flex-md-row mt-3 gap-3"
          style={{ alignItems: "stretch" }}
        >
          <div
            className="mb-3"
            style={{
              flex: "0 0 25%",
              maxWidth: "25%",
            }}
          >
            <ActivityChargesList
              visit_id={props.visit_id}
              Headers={props.Headers}
              selectedTab={props.selectedTab}
              fullWidth
            />
          </div>
          <div className="flex-grow-1">
            <div className="card sh_basecard" style={{ height: "350px" }}>
              <div className="card-header p-2 sh_basecardHeader">
                <div className="d-flex w-100 justify-content-between align-items-center">
                  <span>Previous Visits - Order &amp; Results History</span>
                </div>
              </div>
              <div className="card-body p-0 my-2 px-0 sh_basecardBody">
                {previousTableRecords.tableRows.data.length === 0 ? (
                  <div
                    className="d-flex align-items-center justify-content-center py-3 text-muted"
                    style={{ fontSize: "13px" }}
                  >
                    No previous orders.
                  </div>
                ) : (
                  <TableGrid {...previousTableRecords} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    stateList: state.session.profileStateList,
  };
};
export default connect(mapStateToProps)(withReduxState(WithRouter(WithRoutify(AllOrdersPage))));
// export default AllOrdersPage;
